import { Component, OnInit } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { BackofficeCartridgeService } from '@markant-platform/backoffice/data-access';
import { TranslocoService } from '@jsverse/transloco';
import { CartridgeDto } from '@markant-platform/shared/cartridge/model';

@Component({
  selector: 'markant-platform-variants-overview',
  templateUrl: './variants-overview.component.html',
  styleUrls: ['./variants-overview.component.scss'],
})
export class VariantsOverviewComponent implements OnInit {
  cartridgeIdToCartridgeDTOs$?: Observable<Record<string, CartridgeDto[]>>;

  constructor(
    private readonly cartridgesService: BackofficeCartridgeService,
    private readonly translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.cartridgeIdToCartridgeDTOs$ = this.translocoService.langChanges$.pipe(
      switchMap(() => {
        return this.cartridgesService.getAllCartridgeVariants().pipe(
          map(cartridges => {
            return this.groupByCartridgeId(cartridges);
          })
        );
      })
    );
  }

  //Prevents visual bug
  trackByFn(index: number): number {
    return index;
  }

  private groupByCartridgeId(cartridges: CartridgeDto[]): Record<string, CartridgeDto[]> {
    const cartridgeIdToCartridgeDTOs: Record<string, CartridgeDto[]> = {};
    cartridges.forEach(cartridge => {
      cartridgeIdToCartridgeDTOs[cartridge.cartridgeId] = !cartridgeIdToCartridgeDTOs[cartridge.cartridgeId]
        ? [cartridge]
        : [...cartridgeIdToCartridgeDTOs[cartridge.cartridgeId], cartridge];
    });
    return cartridgeIdToCartridgeDTOs;
  }
}
